export const LANGUAGES = {
  en: {
    dialogConfirmSoundTitle: 'Auto play sound on this website?',
    btnOK: 'OK',
    btnCancel: 'Cancel',
    controlbarFirstScene: 'Go to first scene',
    controlbarInfoTour: 'Info Tour',
    controlbarInfoScene: 'Info Scene',
    controlbarMap: 'Google Map',
    controlbarFloorplan: 'Floorplan',
    controlbarTurnOnSoundProject: 'Unmute sound',
    controlbarTurnOffSoundProject: 'Mute sound',
    controlbarSoundScene: 'Sound scene',
    controlbarStopRotate: 'Stop Rotate',
    controlbarStartRotate: 'Rotate',
    controlbarStartAutoPlayScene: 'Auto play scene',
    controlbarStopAutoPlayScene: 'Stop auto play scene',
    controlbarVRMode: 'VR Mode',
    controlbarFullscreen: 'Fullscreen',
    controlbarViewNormal: 'View Normal',
    controlbarViewPlanet: 'View Little Planet',
    controlbarViewMirrorBall: 'View Mirror Ball',
    controlbarSettingColor: 'Change color',
    controlbarTurnOffModeMultipleStaging: 'Disable Staging',
    controlbarTurnOnModeMultipleStaging: 'Enable Staging',
  },
  vi: {
    dialogConfirmSoundTitle: 'Tự động phát nhạc?',
    btnOK: 'OK',
    btnCancel: 'Huỷ bỏ',
    controlbarFirstScene: 'Cảnh đầu tiên',
    controlbarInfoTour: 'Thông tin tour',
    controlbarInfoScene: 'Thông tin cảnh',
    controlbarFloorplan: 'Floorplan',
    controlbarMap: 'Google Map',
    controlbarTurnOnSoundProject: 'Bật âm lượng',
    controlbarTurnOffSoundProject: 'Tắt âm lượng',
    controlbarSoundScene: 'Âm thanh cảnh',
    controlbarStopRotate: 'Dừng xoay',
    controlbarStartRotate: 'Xoay',
    controlbarStartAutoPlayScene: 'Tự động chuyển cảnh',
    controlbarStopAutoPlayScene: 'Dừng tự động chuyển cảnh',
    controlbarVRMode: 'Chế độ VR',
    controlbarFullscreen: 'Toàn màn hình',
    controlbarViewNormal: 'Chế độ mặc định',
    controlbarViewPlanet: 'Chế độ toàn cầu',
    controlbarViewMirrorBall: 'Chế độ gương',
    controlbarSettingColor: 'Thay đổi màu',
    controlbarTurnOffModeMultipleStaging: 'Tắt chế độ Staging',
    controlbarTurnOnModeMultipleStaging: 'Bật chế độ Staging',
  },
};
